import { useState, useEffect } from "react";

export function useAsyncLoader({ getter, value: defaultValue, key }) {
  const [value, setValue] = useState(defaultValue);
  const [promise, setPromise] = useState(null);
  const retry = () => {
    const p = getter().then(c => (setValue(c), c));
    setPromise(p);
    return p;
  };
  const noValue = value === undefined;
  useEffect(() => {
    if (noValue) retry();
  }, [key]);

  return {
    loaderProps: { promise, retry },
    value,
    reload: retry,
  };
}
